import { Trigger } from '@radix-ui/react-dialog'

export const DialogTrigger = Trigger
